import { chooseIndefiniteArticle } from 'util/strings'
import { shopifyChangeText } from '../util/shopifyChangeText'

const getLinkText = provider => {
  if (provider === 'GITHUB') return 'GitHub issue'
  return 'Unknown integration'
}

const IntegrationAction = ({ provider, removed, title, url, changeType }) => {
  if (provider === 'HUBSPOT') {
    return (
      <React.Fragment>
        <span className="action-verb">created</span> {title} as a{' '}
        <a target="_blank" rel="noopener noreferrer" href={url}>
          contact
        </a>
      </React.Fragment>
    )
  }

  if (provider === 'SALESFORCE') {
    return (
      <React.Fragment>
        <span className="action-verb">created</span> {title} as a{' '}
        <a target="_blank" rel="noopener noreferrer" href={url}>
          lead
        </a>
      </React.Fragment>
    )
  }

  if (['GITHUB', 'JIRA_CLOUD', 'JIRA_SERVER', 'TRELLO'].includes(provider)) {
    return (
      <React.Fragment>
        {removed ? (
          <span>
            <span className="action-verb">unlinked</span> this conversation from{' '}
          </span>
        ) : (
          <span>
            <span className="action-verb">linked</span> this conversation to{' '}
          </span>
        )}
        <a target="_blank" rel="noopener noreferrer" href={url}>
          {title}
        </a>
      </React.Fragment>
    )
  }

  if (provider === 'RECHARGE') {
    const [eventId, resource] = title.split('-')
    return (
      <React.Fragment>
        {resource === 'subscription' && (
          <span>
            <span className="action-verb">
              {removed ? 'cancelled' : 'reactivated'}
            </span>{' '}
            the subscription{' '}
          </span>
        )}
        {resource === 'order' && (
          <span>
            <span className="action-verb">skipped the next order</span> for the
            subscription{' '}
          </span>
        )}
        <a target="_blank" rel="noopener noreferrer" href={url}>
          #{eventId}
        </a>
      </React.Fragment>
    )
  }

  if (provider === 'SHOPIFY_V2' && !!changeType) {
    return (
      <span className="action-verb">
        {shopifyChangeText(changeType.toLowerCase())}&nbsp;
        <a target="_blank" rel="noopener noreferrer" href={url}>
          {title}
        </a>
      </span>
    )
  }

  const linkText = getLinkText(provider)
  const direction = removed ? (
    <span>
      <span className="action-verb">removed</span> this from
    </span>
  ) : (
    <span>
      <span className="action-verb">added</span> this to
    </span>
  )
  const base = `${direction} ${chooseIndefiniteArticle(linkText)} `

  return (
    <React.Fragment>
      {base}
      <a target="_blank" rel="noopener noreferrer" href={url}>
        {linkText}
      </a>
    </React.Fragment>
  )
}

export default IntegrationAction
